export const navigateWithParams = (url: string): void => {
  const queryParams = window.location.search;
  const goToUrl = url + (queryParams || '');
  window.open(goToUrl, '_self');
};
